<!--~
  ~ Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div class='mat-card'>
    <div class='measure-close' (click)='close()'><mat-icon svgIcon='close'></mat-icon></div>
    <div class='measure-instructions'>
        <span><b>Measure distance</b></span><br />
        <span>Click on the map to add to your path</span>
    </div>
    <ng-container *ngIf='data$|async; let event'>
        <div>
            <b>Total distance:</b>
            <span class='measurement'>{{event.measurement.distance.label}}</span>
            <span class='alt-measurement'>({{event.altMeasurement.distance.label}})</span>
        </div>
        <ng-container *ngIf='event.measurement.area'>
            <div>
                <b>Total area:</b>
                <span class='measurement'>{{event.measurement.area.label}}</span>
                <span class='alt-measurement'>({{event.altMeasurement.area.label}})</span>
            </div>
        </ng-container>
    </ng-container>
</div>